import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { useT } from '@/lib/i18n';
import { toast } from 'sonner';

const readSessionIdFromHash = () => {
  const hash = typeof window !== 'undefined' ? window.location.hash : '';
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.get('session_id');
};

const GoogleAuth = () => {
  const { loginWithGoogleSession } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  // Derive at render time so no synchronous setState happens inside the effect body.
  const sessionId = readSessionIdFromHash();
  const [status, setStatus] = useState(() => (sessionId ? t('auth.gconnect') : t('auth.nosession')));

  useEffect(() => {
    if (!sessionId) {
      const tid = setTimeout(() => navigate('/login'), 1200);
      return () => clearTimeout(tid);
    }
    let cancelled = false;
    (async () => {
      try {
        await loginWithGoogleSession(sessionId);
        if (cancelled) return;
        toast.success(t('auth.gsuccess'));
        navigate('/dashboard');
      } catch (e) {
        if (cancelled) return;
        toast.error(t('auth.gfail'));
        setStatus(t('auth.failed'));
        setTimeout(() => navigate('/login'), 1500);
      }
    })();
    return () => { cancelled = true; };
  }, [sessionId, loginWithGoogleSession, navigate, t]);

  return (
    <div className="min-h-screen flex items-center justify-center dot-grid">
      <div className="text-center" data-testid="google-callback">
        <div className="w-10 h-10 mx-auto mb-4 rounded-full border-2 border-[#D4FF00] border-t-transparent animate-spin" />
        <p className="text-zinc-300">{status}</p>
      </div>
    </div>
  );
};

export default GoogleAuth;
